<template>
  <div class="Footer">
    <Menu :items="links" />
    <span class="note">
      Prototype Stadium - Copyright <span>{{ currentYear }}</span>
    </span>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'

export default {
  name: 'Footer',
  components: {
    Menu
  },
  data() {
    return {
      /** 
       * Footer menu items 
       * TODO: Move to store?
       */
      links: [
        {
          label: 'Home',
          to: { name: 'home' },
          alternate: false
        },
        {
          label: 'Contact',
          to: { name: 'page-contact' },
          alternate: false
        },
        {
          label: 'Project Aanmelden',
          to: { name: 'page-aanmaken' }
        },
        // {
        //   label: 'Stage Plaatsen',
        //   to: { name: 'page-stage' }
        // },
        // {
        //   label: 'Colofon',
        //   to: { name: 'page-colofon' },
        //   alternate: false
        // }
      ]
    }
  },
  computed: {
    currentYear() {
      return '2019';
    }
  }
}
</script>

<style lang="scss">

  .Footer {
    display: flex;
    padding: 8px 24px;
    border-top: 1px solid $gray_mid;
    background: $antraciet_blauw_lightest;
    font-size: 12px;
    font-family: $font_nav;
    justify-content: space-between;

    .Menu {
      &__link {
        margin-right: 24px;
        display: inline;
      }
    }
    .note {

      a {
        color: black;
        text-decoration: none;
      }
    }
  }

</style>
